import React, { useEffect, useState } from 'react'
import Accordion from '@mui/material/Accordion'
import AccordionSummary from '@mui/material/AccordionSummary'
import AccordionDetails from '@mui/material/AccordionDetails'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import TimelineItem from '@mui/lab/TimelineItem'
import TimelineSeparator from '@mui/lab/TimelineSeparator'
import TimelineConnector from '@mui/lab/TimelineConnector'
import TimelineDot from '@mui/lab/TimelineDot'
import Typography from '@mui/material/Typography'
import { formatLocal, formatUTC } from 'utils/date'

import { translate } from 'locales'

import { CardDate, Loading } from 'components'
import noData from 'assets/images/no-data.svg'
import { useUser } from 'context/user/user.context'

import { findAllMedicalRecordsFollowUp } from './services'

import * as N from '../New/styles'
import {
  Timeline,
  TimelineContent,
  TimelineOppositeContent,
  AccordionHeadingTypographyResponsive,
} from '../timelineStyles'

import TimeLineFollowUp from './TimeLineFollowUp'

interface IResume {
  userUUID: string
}

const FollowUp: React.FunctionComponent<IResume> = ({ userUUID }) => {
  const { userData } = useUser()

  const [records, setRecords] = useState<any>({})
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    findAllMedicalRecordsFollowUp(userUUID, setRecords, setLoading)

    // eslint-disable-next-line
  }, [userData])

  return (
    <>
      {loading && <Loading title={translate('medicalRecord.loadingData')} />}
      <Timeline position="right">
        {records && Object.keys(records).length === 0 && (
          <N.NoData>
            <img
              src={noData}
              alt="Icone simbolizando que não existe acompanhamento a serem exibidas"
            />
            <span>{translate('medicalRecord.notAccompaniment')}</span>
          </N.NoData>
        )}

        {records.medicalRecordsFollowUp &&
          Object.keys(records.medicalRecordsFollowUp).map((item) => (
            <TimelineItem key={item}>
              <TimelineOppositeContent>
                <CardDate
                  day={formatUTC(item, 'dd')}
                  month={formatUTC(item, 'MMM')}
                  year={formatUTC(item, 'yyyy')}
                />
              </TimelineOppositeContent>
              <TimelineSeparator>
                <TimelineDot />
                <TimelineConnector />
              </TimelineSeparator>
              <TimelineContent>
                {records.medicalRecordsFollowUp[item].map((i: any) => (
                  <Accordion key={i.id}>
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel1a-content"
                      id={i.id}
                    >
                      <AccordionHeadingTypographyResponsive
                        style={{
                          marginTop: 0,
                          display: 'flex',
                          flex: 1,
                          justifyContent: 'space-between',
                          alignItems: 'center',
                        }}
                      >
                        {`${translate('medicalRecord.by')}  ${i.nursing?.name}`}

                        <Typography
                          style={{
                            marginTop: 0,
                          }}
                        >
                          {`(${i.specialty_name})`}
                        </Typography>
                      </AccordionHeadingTypographyResponsive>
                    </AccordionSummary>
                    <AccordionDetails style={{ display: 'block', padding: 0 }}>
                      <TimeLineFollowUp history={i} />
                    </AccordionDetails>
                  </Accordion>
                ))}
              </TimelineContent>
            </TimelineItem>
          ))}
      </Timeline>
    </>
  )
}

export default FollowUp
